<template>
  <div class="input-wrapper">
    <input :class="[
      isSmall ? 'aoi-input-sm' : 'aoi-input',
      { 'is-error': error }
    ]" :type="type" :placeholder="placeholder" :disabled="disabled" :value="value"
      @input="$emit('input', $event.target.value)" @focus="$emit('focus', $event)" @blur="$emit('blur', $event)"
      autocomplete="off" :aria-invalid="error ? 'true' : 'false'" />

    <!-- Error message (same pattern as BaseSelect) -->
    <div v-if="error && errorMessage" class="input-error-container">
      <img :src="errorLogo" alt="Input error icon" class="input-error-icon" />
      <span class="input-error">{{ errorMessage }}</span>
    </div>
  </div>
</template>

<script>
import errorLogo from "@/assets/error-icon.svg";

export default {
  name: 'vpd-input',
  props: {
    value: [String, Number],
    placeholder: String,
    type: { type: String, default: 'text' },
    disabled: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
    errorMessage: { type: String, default: '' },
    isSmall: { type: Boolean, default: false },
  },
  data() {
    return {
      errorLogo
    };
  }
};
</script>

<style scoped>
.input-wrapper {
  display: inline-block;
}

/* main input */
.aoi-input {
  width: 326px;
  height: 44px;
  background: #ffffff;
  border: 1px solid #9E9E9E;
  border-radius: 8px;
  padding: 0 16px;
  color: #111;
  font-size: 16px;
  line-height: 1;
  outline: none;
  transition: border-color .15s ease, box-shadow .15s ease, background-color .15s ease;
}

.aoi-input-sm {
  width: 155px;
  height: 44px;
  background: #ffffff;
  border: 1px solid #9E9E9E;
  border-radius: 8px;
  padding: 0 16px;
  color: #111;
  font-size: 16px;
  line-height: 1;
  outline: none;
  transition: border-color .15s ease, box-shadow .15s ease, background-color .15s ease;
  text-align: left;
}

.aoi-input-sm::placeholder {
  text-align: right;
}

/* placeholder tone similar to design tools */
.aoi-input::placeholder {
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;
  color: #656565;
}

/* focus state */
.aoi-input:focus {
  box-shadow: 0 0 0 3px rgba(59, 130, 246, .15);
}

/* disabled */
.aoi-input:disabled {
  background: #f7f7f7;
  color: #9ca3af;
  cursor: not-allowed;
}

/* error variant – match the select look */
.aoi-input.is-error {
  border-color: #D64040 !important;
  border-width: 2px;
  background-color: unset !important;
  box-shadow: none;
}

/* error row (same style as select-error-container) */
.input-error-container {
  display: flex;
  align-items: center;
  margin-top: 4px;
  font-size: 13px;
  line-height: 1.4;
}

.input-error-icon {
  height: 18px;
  margin-right: 6px;
}

.input-error {
  color: #D64040;
}

@media (max-width: 767px) {
  .input-wrapper {
    width: 100%;
  }

  .aoi-input-sm {
    width: 100%;
  }
}

@media (max-width: 575px) {
  .input-wrapper {
    width: 100%;
  }
}

@media (max-width: 375px) {
  .aoi-input-sm {
    width: 100%;
  }
}
</style>
